import { getRandomNum, lastSevenDayData } from "@/utils/index.js";

export function tunnelssData() {
  return [
    {
        "tunnelNumber": "7370301d2bcf48a4a5b94a0669e4ad37",
        "pileNoMark": "ZK",
        "invert": {
            "yearPlan": 0,
            "quantity": 1370,
            "totalCompleted": 144,
            "lmPrice": 1,
            "rockSurrounding": "5",
            "monthCompleted": 0,
            "lastYearCompleted": 144,
            "projectName": "仰拱",
            "monthPlan": 0,
            "yearCompleted": 0
        },
        "startingMileage": 24845,
        "tunnelLength": 1370,
        "pileNoOrient": "1",
        "showScale": null,
        "tunnelType": "2",
        "excavation": {
            "yearPlan": 0,
            "quantity": 1370,
            "totalCompleted": 208.4,
            "lmPrice": 1,
            "rockSurrounding": "5",
            "monthCompleted": 0,
            "lastYearCompleted": 208.4,
            "projectName": "开挖",
            "monthPlan": 0,
            "yearCompleted": 0
        },
        "lining": {
            "yearPlan": 0,
            "quantity": 1370,
            "totalCompleted": 84,
            "lmPrice": 1,
            "rockSurrounding": "5",
            "monthCompleted": 0,
            "lastYearCompleted": 84,
            "projectName": "衬砌",
            "monthPlan": 0,
            "yearCompleted": 0
        },
        "waterproofTrolley": {
            "distance": 110,
            "mileage": 24958
        },
        "excavationTrolley": {
            "distance": 206,
            "mileage": 25050
        },
        "tunnelName": "公鸡山隧道进口左洞",
        "archBridge": {
            "distance": 144,
            "mileage": 24989
        },
        "liningTrolley": {
            "distance": 84,
            "mileage": 24929
        }
    },
    {
        "tunnelNumber": "d4077a4afea9491184c431ec4d4b09cf",
        "pileNoMark": "D1K",
        "invert": {
            "yearPlan": 0,
            "quantity": 1415,
            "totalCompleted": 84,
            "lmPrice": 1,
            "rockSurrounding": "5",
            "monthCompleted": 0,
            "lastYearCompleted": 84,
            "projectName": "仰拱",
            "monthPlan": 0,
            "yearCompleted": 0
        },
        "startingMileage": 24835,
        "tunnelLength": 1415,
        "pileNoOrient": "1",
        "showScale": null,
        "tunnelType": "3",
        "excavation": {
            "yearPlan": 0,
            "quantity": 1415,
            "totalCompleted": 155,
            "lmPrice": 1,
            "rockSurrounding": "5",
            "monthCompleted": 0,
            "lastYearCompleted": 155,
            "projectName": "开挖",
            "monthPlan": 0,
            "yearCompleted": 0
        },
        "lining": {
            "yearPlan": 0,
            "quantity": 1415,
            "totalCompleted": 36,
            "lmPrice": 1,
            "rockSurrounding": "5",
            "monthCompleted": 0,
            "lastYearCompleted": 36,
            "projectName": "衬砌",
            "monthPlan": 0,
            "yearCompleted": 0
        },
        "waterproofTrolley": {
            "distance": 48,
            "mileage": 24886
        },
        "excavationTrolley": {
            "distance": 155,
            "mileage": 24990
        },
        "tunnelName": "公鸡山隧道进口右洞",
        "archBridge": {
            "distance": 84,
            "mileage": 24919
        },
        "liningTrolley": {
            "distance": 36,
            "mileage": 24871
        }
    }
];
}

export function tunnelStepData() {
  return [
    {
        "id": "69a10fbb39479e31bcacf7db",
        "areaCode": "19",
        "tunnelNumber": "7370301d2bcf48a4a5b94a0669e4ad37",
        "stepArea": "右洞",
        "stepTime": "2026-02-27 02:29:00",
        "stepType": "",
        "erChenData": "0",
        "fangShuiData": "54.00",
        "yangGongData": "0",
        "stepErchenData": "0"
    },
    {
        "id": "69a0f39a39479e31bcabc737",
        "areaCode": "19",
        "tunnelNumber": "7370301d2bcf48a4a5b94a0669e4ad37",
        "stepArea": "右洞",
        "stepTime": "2026-02-27 03:29:01",
        "stepType": "",
        "erChenData": "0",
        "fangShuiData": "0",
        "yangGongData": "0",
        "stepErchenData": "13.00"
    },
    {
        "id": "69a0f39a39479e31bcabc737",
        "areaCode": "19",
        "tunnelNumber": "7370301d2bcf48a4a5b94a0669e4ad37",
        "stepArea": "右洞",
        "stepTime": "2026-02-27 04:29:01",
        "stepType": "",
        "erChenData": "0",
        "fangShuiData": "0",
        "yangGongData": "0",
        "stepErchenData": "13.00"
    },
    {
        "id": "69a0f39a39479e31bcabc737",
        "areaCode": "19",
        "tunnelNumber": "7370301d2bcf48a4a5b94a0669e4ad37",
        "stepArea": "右洞",
        "stepTime": "2026-02-27 05:29:01",
        "stepType": "",
        "erChenData": "0",
        "fangShuiData": "0",
        "yangGongData": "0",
        "stepErchenData": "13.00"
    },
    {
        "id": "69a0f39a39479e31bcabc737",
        "areaCode": "19",
        "tunnelNumber": "7370301d2bcf48a4a5b94a0669e4ad37",
        "stepArea": "右洞",
        "stepTime": "2026-02-27 06:29:01",
        "stepType": "",
        "erChenData": "0",
        "fangShuiData": "0",
        "yangGongData": "0",
        "stepErchenData": "13.00"
    }
]
}

export function StatisticsData() {
  let dataDom = [];

  lastSevenDayData().forEach((itemDate) => {
    dataDom.push({
      date: itemDate.startTime,
      value: getRandomNum(0, 40),
    });
  });

  return dataDom;
}
